import React from "react";
import CustomRichText from "../../CustomRichText";
import SliceFooterActions from "../SliceFooterActions";
import { graphql } from "gatsby";
import { CalloutBox } from "../../design-system/CalloutBox";
import { Button } from "../../design-system/Buttons";
import { GaEventNames, trackGa } from "../../../helpers/track";

export interface ColumnTextProps {
  slice: any;
  context?: any;
}

/**
 * @typedef {import("@prismicio/client").Content.CalloutSlice} CalloutSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<CalloutSlice>} CalloutProps
 * @param { CalloutProps }
 */
const Callout = ({ slice, context }: ColumnTextProps) => {
  const content = slice.primary.content ? (
    <CustomRichText field={slice.primary.content.richText} context={context} />
  ) : (
    <></>
  );

  console.log(slice.primary.cta_url.target);

  return (
    <CalloutBox position={slice.primary.horizontal_position || "right"}>
      {content}
      {!!slice.primary.cta_url.url && (
        <Button
          as="a"
          href={slice.primary.cta_url.url}
          $color="richBlack"
          variant="outlined"
          target={slice.primary.cta_url.target || "_self"}
          onClick={() => {
            trackGa({
              event: GaEventNames.selectContent,
              content_type: "CTA button",
              item_id: slice.primary.label || "Lean more",
            });
          }}
        >
          {slice.primary.label || "Learn more"}
        </Button>
      )}
    </CalloutBox>
  );
};

export default Callout;

export const query = graphql`
  fragment CalloutDefault on PrismicCalloutDefault {
    id
    slice_type
    slice_label
    variation
    primary {
      content {
        richText
      }
      cta_label
      cta_url {
        url
        target
      }
    }
  }
`;
